module.exports = __webpack_public_path__ + "6786546363c0261228fd66d68bbf27e9.ttf";